function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import WC from 'wc-util';

/*
  This uses JQuery!

  attributes:   href
                insert (optional) - "top" or "bottom", inserts resulting content rather than
                                    replace the entire element content
                extra-params (optional) - JSON of initial extra_params
                lazyload (optional)     - don't immediately load the content

  properties:  extra_params - a plain object passed in to subsequent AJAX load requests;
                              when setting, you can provide a plain object or a "railsy" request string (the setter converts the string to an object)

  methods: load() - forces the element to fetch new content via AJAX, using it's @href and #extra_params
           update_extra_params(param_name, value) - sets the value of existing extra_params'
                                                    key identified by param_name (key
                                                    can be complex like "filter[id][]")

  events: ts-load - fired before loading. Can be cancelled
          ts-loaded - fired once the content is updated after a load()

  interactivity cues: ts-loadable.loading - class appended during load(); cleared when content is updated

*/
var TsLoadable = /*#__PURE__*/function (_HTMLElement) {
  function TsLoadable() {
    _classCallCheck(this, TsLoadable);
    return _callSuper(this, TsLoadable, arguments);
  }
  _inherits(TsLoadable, _HTMLElement);
  return _createClass(TsLoadable, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // set initial extra_params
      this.extra_params = this.hasAttribute("extra-params") ? JSON.parse(this.getAttribute("extra-params")) : {};

      // load on startup unless told otherwise
      if (!this.hasAttribute("lazyload")) {
        this.load();
      }
    }
  }, {
    key: "extra_params",
    get: function get() {
      return this._extra_params;
    },
    set: function set(string_or_object) {
      // url_request params or hash/object
      this._extra_params = typeof string_or_object == "string" ? WC.serialize_as_object(string_or_object) : string_or_object;
    }
  }, {
    key: "update_extra_params",
    value: function update_extra_params(param_name, value) {
      if (!(_typeof(this._extra_params) == "object")) {
        this._extra_params = {};
      }
      WC.railsy_update_property_hash(this._extra_params, param_name, value);
    }
  }, {
    key: "load",
    value: function load(force) {
      var el = this;

      // allow listeners to prevent variant change
      if (!force && !WC.fireEvent(this, "ts-load")) {
        return false;
      }
      el.classList.add("loading");
      el._current_jqxhr && el._current_jqxhr.abort(); // kill possible pending request

      this._current_jqxhr = WC.$get(this.getAttribute('href'), this.extra_params, function (responseText, textStatus, jqXHR) {
        el._current_jqxhr = null;
        if (el.getAttribute("insert") == "top") {
          WC.prepend(el, responseText);
        } else if (el.getAttribute("insert") == "bottom") {
          WC.append(el, responseText);
        } else {
          WC.html(el, responseText); // use jquery instead of innerHTML so that JS gets executed
        }
        WC.fireEvent(el, "ts-loaded");
        el.classList.remove("loading");
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
;
customElements.define('ts-loadable', TsLoadable);